<div id="gridContainer" *ngrxLet="viewModel$; let value">
  @if (value.state.loading) {
    <mat-progress-bar mode="indeterminate"
                      class="absolute z-50"
    ></mat-progress-bar>
  }

  <ag-grid-angular
      style="width: 100%; height: 100%"
      class="ag-theme-material"
      [defaultColDef]="defaultColumnDefs"
      [columnDefs]="columnDefs"
      [gridOptions]="gridOptions"
      [rowData]="value?.state?.blsUpdates"
      (gridReady)="onGridReady($event)"
      (gridSizeChanged)="onGridSizeChanged($event)"
      (rowDataUpdated)="onRowDataUpdated($event)"
  ></ag-grid-angular>

  <div id="actionBarContainer">
    <div class="flex-grow"></div>

    <app-jumper
      [currentItemIndex]="value.focusedRowOneBasedIndex !== undefined ? value.focusedRowOneBasedIndex : 0"
      [numberOfItems]="value.total !== undefined ? value.total : 0"
      (currentItemChanged)="changeCurrentRow($event)"
      [showSideArrows]="true">
    </app-jumper>
  </div>

</div>

